import loginPage from "./login.component";
import loginUrls from "./login.urls";

const listTableModule = angular
  .module("app.pages.login", [])
  .component("loginPage", loginPage)
  .config(loginUrls);

export default listTableModule;



// WEBPACK FOOTER //
// ./src/pages/login/login.module.js